import React, { Fragment, useState, useRef, useEffect } from "react";
import { closeModal } from "../../store/modal/modalReducer";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import ErrorBoundary from "../../containers/ErrorBoundary";
import axios from "axios";

export default function ModalFilterMessages(props) {
	const dispatch = useDispatch();
	const [open] = useState(true);
	const filterProp = useRef();
	const filterGender = useRef();
	const filterFunding = useRef();
	const filterVendor = useRef();
	const filterStatus = useRef();
	const filterDoc = useRef();
	const filterStudyYear = useRef();
	const filterUnitType = useRef();
	const filterBookingSummary = useRef();
	const filterBudget = useRef();
	const filterBotFlow = useRef();
	const filterAppointment = useRef();
	const filterRenewalChoice = useRef();
	const filterTenantType = useRef();
	const [balanceType, setBalanceType] = useState(props.filterBalance?.id || "");
	const [balanceMin, setBalanceMin] = useState(props.filterBalance?.min || "");
	const [balanceMax, setBalanceMax] = useState(props.filterBalance?.max || "");

	const vendor_data = [
		{ value: 1, label: "Fundi" },
		{ value: 2, label: "AE switch" },
		{ value: 3, label: "Embizo" },
	];
	const status_data = [
		{ value: 1, label: "Absconded" },
		{ value: 2, label: "Bursar Invoice Sent" },
		{ value: 3, label: "Contacted" },
		{ value: 4, label: "Docs Loaded" },
		{ value: 5, label: "Ex-tenant" },
		{ value: 6, label: "Funds Loaded" },
		{ value: 7, label: "Wits Invoice Sent" },
		{ value: 8, label: "No Response" },
		{ value: 9, label: "Not Funded" },
		{ value: 10, label: "Not moved-in (Lease)" },
		{ value: 11, label: "Not moved-in (No Lease)" },
		{ value: 12, label: "Paid" },
		{ value: 13, label: "Verified" },
		{ value: 14, label: "Verify error" },
		{ value: 15, label: "Bad Debt" },
		{ value: 16, label: "Awaiting Funds" },
		{ value: 17, label: "Payment Arrangement" },
		{ value: 18, label: "PNYA" },
		{ value: 19, label: "No Status" },
		{ value: 20, label: "Appealing" },
		{ value: 21, label: "Appeals" },
		{ value: 22, label: "Provisionally Funded" },
	];

	const botFlowTypes = [
		{ label: "All Robots", value: "" },
		{ label: "Red", value: "1" },
		{ label: "Green", value: "2" },
		{ label: "Bot Flow", value: "3" }
	];

	const appointmentTypes = [
		{ label: "Ignore Appointments", value: "" },
		{ label: "Appointment Today", value: "today" },
		{ label: "Appointment This Week", value: "this_week" },
		{ label: "Appointment Next Week", value: "next_week" },
		{ label: "Appointment This Month", value: "this_month" },
		{ label: "Appointment Overdue", value: "overdue" },
		{ label: "Has Any Appointment", value: "any" },
		{ label: "No Appointments", value: "none" },
	];

	const renewalChoiceOptions = [
		{ label: "All Renewal Choices", value: "" },
		{ label: "YES, RENEW", value: "YES, RENEW" },
		{ label: "REMAIN MONTH 2 MONTH", value: "REMAIN MONTH 2 MONTH" },
		{ label: "MONTH 2 MONTH LEAVING", value: "MONTH 2 MONTH LEAVING" },
		{ label: "LEAVING, END JAN", value: "LEAVING, END JAN" },
		{ label: "LEAVING, END FEB", value: "LEAVING, END FEB" },
		{ label: "LEAVING, END MAR", value: "LEAVING, END MAR" },
		{ label: "LEAVING, END APR", value: "LEAVING, END APR" },
		{ label: "LEAVING, END MAY", value: "LEAVING, END MAY" },
		{ label: "LEAVING, END JUN", value: "LEAVING, END JUN" },
		{ label: "LEAVING, END JUL", value: "LEAVING, END JUL" },
		{ label: "LEAVING, END AUG", value: "LEAVING, END AUG" },
		{ label: "LEAVING, END SEP", value: "LEAVING, END SEP" },
		{ label: "LEAVING, END OCT", value: "LEAVING, END OCT" },
		{ label: "LEAVING, END NOV", value: "LEAVING, END NOV" },
		{ label: "LEAVING, END DEC", value: "LEAVING, END DEC" },
	];

	const tenantTypeOptions = [
		{ label: "All Tenant Types", value: "" },
		{ label: "Lease Holder", value: "LH" },
		{ label: "Co-Applicant", value: "CA" },
		{ label: "Tenant", value: "TN" },
		{ label: "Main Resident", value: "MR" },
		{ label: "Co Resident", value: "CR" },
		{ label: "Funder", value: "FN" },
		{ label: "Nominee", value: "NM" },
		{ label: "Previous Buyer", value: "PB" },
	];

	function doFilter() {
		if (filterProp.current.value > 0) {
			props.setFilterLocation({
				id: parseInt(filterProp.current.value),
				name: filterProp.current[filterProp.current.selectedIndex].text,
			});
		} else {
			props.setFilterLocation({ id: 0, name: "" });
		}

		if (process.env.REACT_APP_COLOUR === "UC") {
			if (filterGender.current.value > 0) {
				props.setFilterGender({
					id: parseInt(filterGender.current.value),
					name: filterGender.current[filterGender.current.selectedIndex].text,
				});
			} else {
				props.setFilterGender({ id: 0, name: "" });
			}

			if (filterFunding.current.value > 0) {
				props.setFilterFunding({
					id: parseInt(filterFunding.current.value),
					name: filterFunding.current[filterFunding.current.selectedIndex].text,
				});
			} else {
				props.setFilterFunding({ id: 0, name: "" });
			}

			if (filterStudyYear.current.value > 0) {
				props.setFilterStudyYear({
					id: parseInt(filterStudyYear.current.value),
					name: filterStudyYear.current[filterStudyYear.current.selectedIndex]
						.text,
				});
			} else {
				props.setFilterStudyYear({ id: 0, name: "" });
			}

			if (filterBudget.current.value > 0) {
				props.setFilterBudget({
					id: parseInt(filterBudget.current.value),
					name: filterBudget.current[filterBudget.current.selectedIndex].text,
				});
			} else {
				props.setFilterBudget({ id: 0, name: "" });
			}

			if (filterUnitType.current.value > 0) {
				props.setFilterUnitType({
					id: parseInt(filterUnitType.current.value),
					name: filterUnitType.current[filterUnitType.current.selectedIndex]
						.text,
				});
			} else {
				props.setFilterUnitType({ id: 0, name: "" });
			}

			if (filterBookingSummary.current.value > 0) {
				props.setFilterBookingSummary({
					id: parseInt(filterBookingSummary.current.value),
					name: filterBookingSummary.current[
						filterBookingSummary.current.selectedIndex
					].text,
				});
			} else {
				props.setFilterBookingSummary({ id: 0, name: "" });
			}

			if (filterBotFlow.current.value !== "") {
				props.setFilterBotFlow({
					id: parseInt(filterBotFlow.current.value),
					name: botFlowTypes.find(type => type.value === filterBotFlow.current.value)?.label
				});
			} else {
				props.setFilterBotFlow({ id: 0, name: "" });
			}
		}

		if (props.type === "collections") {
			if (filterVendor.current.value > 0) {
				props.setFilterVendor({
					id: parseInt(filterVendor.current.value),
					name: filterVendor.current[filterVendor.current.selectedIndex].text,
				});
			} else {
				props.setFilterVendor({ id: 0, name: "" });
			}

			if (filterStatus.current.value > 0) {
				props.setFilterStatus({
					id: parseInt(filterStatus.current.value),
					name: filterStatus.current[filterStatus.current.selectedIndex].text,
				});
			} else {
				props.setFilterStatus({ id: 0, name: "" });
			}
		} else {
			props.setFilterVendor({ id: 0, name: "" });
			props.setFilterStatus({ id: 0, name: "" });
		}

		// setFilterGender

		if (
			props.type != "management" &&
			props.type != "mentions" &&
			props.type != "collections"
		) {
			axios({
				method: "get",
				url: `${process.env.REACT_APP_API_URL}event/${props.type}`,
			});
		}

		if (props.type == "management") {
			axios({
				method: "get",
				url: `${process.env.REACT_APP_API_URL}tag_event/${props.tag_id}`,
			});
		}

		if (props.type == "collections") {
			axios({
				method: "get",
				url: `${process.env.REACT_APP_API_URL}collection_event/${props.collection_tag_id}`,
			});
		}

		if (props.type == "mentions") {
			axios({
				method: "get",
				url: `${process.env.REACT_APP_API_URL}mentions/${props.current_staff_id}`,
			});
		}

		if (filterDoc.current && filterDoc.current.value !== "") {
			props.setFilterDocuments({
				id: filterDoc.current.value,
				name: filterDoc.current[filterDoc.current.selectedIndex].text,
			});
		} else if (filterDoc.current) {
			props.setFilterDocuments({ id: 0, name: "" });
		}

		if (filterAppointment.current && filterAppointment.current.value !== "") {
			props.setFilterAppointment({
				id: filterAppointment.current.value,
				name: appointmentTypes.find(t => t.value === filterAppointment.current.value)?.label || "",
			});
		} else if (filterAppointment.current) {
			props.setFilterAppointment({ id: 0, name: "" });
		}

		if (filterRenewalChoice.current && filterRenewalChoice.current.value !== "") {
			props.setFilterRenewalChoice({
				id: filterRenewalChoice.current.value,
				name: renewalChoiceOptions.find(t => t.value === filterRenewalChoice.current.value)?.label || "",
			});
		} else if (filterRenewalChoice.current) {
			props.setFilterRenewalChoice({ id: 0, name: "" });
		}

		if (filterTenantType.current && filterTenantType.current.value !== "") {
			props.setFilterTenantType({
				id: filterTenantType.current.value,
				name: tenantTypeOptions.find(t => t.value === filterTenantType.current.value)?.label || "",
			});
		} else if (filterTenantType.current) {
			props.setFilterTenantType({ id: 0, name: "" });
		}

		if (balanceType !== "") {
			props.setFilterBalance({
				id: balanceType,
				name: balanceType === "ok" ? "Balance OK" : "Balance Outstanding",
				min: balanceType === "outstanding" ? balanceMin : "",
				max: balanceType === "outstanding" ? balanceMax : "",
			});
		} else {
			props.setFilterBalance({ id: 0, name: "" });
		}

		dispatch(closeModal());
	}

	// console.log(props)

	return (
		<Transition.Root show={open} as={Fragment}>
			<Dialog
				as="div"
				static
				className="fixed z-50 inset-0 overflow-y-auto"
				open={open}
				onClose={() => dispatch(closeModal())}
			>
				<div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
					</Transition.Child>

					{/* This element is to trick the browser into centering the modal contents. */}
					<span
						className="hidden sm:inline-block sm:align-middle sm:h-screen"
						aria-hidden="true"
					>
						&#8203;
					</span>

					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						enterTo="opacity-100 translate-y-0 sm:scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 translate-y-0 sm:scale-100"
						leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
					>
						<div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6">
							<div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
								<Dialog.Title
									as="h1"
									className="text-lg font-medium text-gray-900 capitalize"
								>
									Filter Chat by Property{" "}
									{process.env.REACT_APP_COLOUR === "UC" ? " & Gender" : ""}{" "}
									{props.type === "collections" ? " & Vendor & Status" : ""}
								</Dialog.Title>

								<Dialog.Panel>
									<ErrorBoundary>
										<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
											<select
												name="property_id"
												ref={filterProp}
												className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
											>
												<option value="">All Buildings</option>
												<option
													value="1000"
													selected={
														"1000" == props.filterLocation.id
															? "selected"
															: false
													}
												>
													No Building
												</option>

												{props.properties &&
													props.properties.length > 0 &&
													props.properties.map((p) => (
														<option
															key={p.value}
															value={p.value}
															selected={
																p.value == props.filterLocation.id
																	? "selected"
																	: false
															}
														>
															{p.label}
														</option>
													))}
											</select>

											{process.env.REACT_APP_COLOUR === "UC" ? (
												<>
													<select
														name="gender_id"
														ref={filterGender}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													>
														<option value="">All Genders</option>

														{props.genderOptions &&
															props.genderOptions.length > 0 &&
															props.genderOptions.map((p) => (
																<option
																	key={p.value}
																	value={p.value}
																	selected={
																		p.value == props.filterGender.id
																			? "selected"
																			: false
																	}
																>
																	{p.label}
																</option>
															))}
													</select>

													<select
														name="gender_id"
														ref={filterFunding}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													>
														<option value="">All Funding</option>

														{props.fundingOptions &&
															props.fundingOptions.length > 0 &&
															props.fundingOptions.map((p) => (
																<option
																	key={p.value}
																	value={p.value}
																	selected={
																		p.value == props.filterFunding.id
																			? "selected"
																			: false
																	}
																>
																	{p.label}
																</option>
															))}
													</select>

													<select
														name="study_year_id"
														ref={filterStudyYear}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													>
														<option value="">All Study Years</option>

														{props.lookups[8] &&
															props.lookups[8].length > 0 &&
															props.lookups[8].map((p) => (
																<option
																	key={p.value}
																	value={p.value}
																	selected={
																		p.value == props.filterStudyYear.id
																			? "selected"
																			: false
																	}
																>
																	{p.label}
																</option>
															))}
													</select>

													<select
														name="unit_type_id"
														ref={filterUnitType}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													>
														<option value="">Ignore Unit Type</option>
														<option
															value="1"
															selected={
																props.filterUnitType.id == 1
																	? "selected"
																	: false
															}
														>
															Has Unit Type
														</option>
														<option
															value="2"
															selected={
																props.filterUnitType.id == 2
																	? "selected"
																	: false
															}
														>
															No Unit Type
														</option>
													</select>

													<select
														name="booking_summary"
														ref={filterBookingSummary}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													>
														<option value="">Ignore Booking Summary</option>
														<option
															value="1"
															selected={
																props.filterBookingSummary.id == 1
																	? "selected"
																	: false
															}
														>
															Has Booking Summary
														</option>
														<option
															value="2"
															selected={
																props.filterBookingSummary.id == 2
																	? "selected"
																	: false
															}
														>
															No Booking Summary
														</option>
													</select>

													<select
														name="budget_id"
														ref={filterBudget}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													>
														<option value="">All Budgets</option>

														{props.lookups[15] &&
															props.lookups[15].length > 0 &&
															props.lookups[15].map((p) => (
																<option
																	key={p.value}
																	value={p.value}
																	selected={
																		p.value == props.filterBudget.id
																			? "selected"
																			: false
																	}
																>
																	{p.label}
																</option>
															))}
													</select>

													<select
														name="bot_flow"
														ref={filterBotFlow}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													>
														{botFlowTypes.map(type => (
															<option
																key={type.value}
																value={type.value}
																selected={type.value === props.filterBotFlow?.id?.toString()}
															>
																{type.label}
															</option>
														))}
													</select>
												</>
											) : (
												""
											)}

											{props.type === "collections" ? (
												<>
													<select
														name="vendor_id"
														ref={filterVendor}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													>
														<option value="">All Vendor</option>

														{vendor_data &&
															vendor_data.length > 0 &&
															vendor_data.map((v) => (
																<option
																	key={v.value}
																	value={v.value}
																	selected={
																		v.value == props.filterVendor.id
																			? "selected"
																			: false
																	}
																>
																	{v.label}
																</option>
															))}
													</select>

													<select
														name="status_id"
														ref={filterStatus}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													>
														<option value="">All Status</option>

														{status_data &&
															status_data.length > 0 &&
															status_data.map((s) => (
																<option
																	key={s.value}
																	value={s.value}
																	selected={
																		s.value == props.filterStatus.id
																			? "selected"
																			: false
																	}
																>
																	{s.label}
																</option>
															))}
													</select>
												</>
											) : (
												""
											)}

											<select
												name="appointment_filter"
												ref={filterAppointment}
												className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
											>
												{appointmentTypes.map(type => (
													<option
														key={type.value}
														value={type.value}
														selected={type.value === (props.filterAppointment?.id || "")}
													>
														{type.label}
													</option>
												))}
											</select>

											{process.env.REACT_APP_COLOUR === "QL" && (
												<select
													name="renewal_choice_filter"
													ref={filterRenewalChoice}
													className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
												>
													{renewalChoiceOptions.map(type => (
														<option
															key={type.value}
															value={type.value}
															selected={type.value === (props.filterRenewalChoice?.id || "")}
														>
															{type.label}
														</option>
													))}
												</select>
											)}

											<select
												name="balance"
												value={balanceType}
												onChange={(e) => setBalanceType(e.target.value)}
												className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
											>
												<option value="">All Balances</option>
												<option value="ok">Balance OK</option>
												<option value="outstanding">Balance Outstanding</option>
											</select>

											{balanceType === "outstanding" && (
												<>
													<input
														type="number"
														placeholder="Min (R)"
														value={balanceMin}
														onChange={(e) => setBalanceMin(e.target.value)}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													/>
													<input
														type="number"
														placeholder="Max (R)"
														value={balanceMax}
														onChange={(e) => setBalanceMax(e.target.value)}
														className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
													/>
												</>
											)}

											{process.env.REACT_APP_COLOUR === "UC" && (
												<select
													name="documents"
													ref={filterDoc}
													className="mt-1 block border font-light border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-primary sm:text-sm transition ease-linear duration-10 hover:border-primary"
												>
													<option value="" selected={props.filterDocuments?.id === "" || props.filterDocuments?.id === 0}>
														All Documents
													</option>
													<option value="missing" selected={props.filterDocuments?.id === "missing"}>
														Missing Required Documents
													</option>
													<option value="uploaded" selected={props.filterDocuments?.id === "uploaded"}>
														All Documents Uploaded
													</option>
												</select>
											)}
										</div>

										<div className="sm:col-span-2 lg:col-span-3 flex justify-between items-center mt-4">
											<button
												className="relative justify-center inline-flex text-gray-700 uppercase items-center px-6 py-2 rounded-full border text-sm focus:z-10 focus:outline-none border-gray-300 bg-white hover:bg-gray-50 focus:ring-gray-400 focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 shadow-sm font-bold"
												onClick={() => {
													props.setFilterLocation({ id: 0, name: "" });
													props.setFilterGender({ id: 0, name: "" });
													props.setFilterFunding({ id: 0, name: "" });
													props.setFilterVendor({ id: 0, name: "" });
													props.setFilterStatus({ id: 0, name: "" });
													props.setFilterStudyYear({ id: 0, name: "" });
													props.setFilterUnitType({ id: 0, name: "" });
													props.setFilterBookingSummary({ id: 0, name: "" });
													props.setFilterBudget({ id: 0, name: "" });
													props.setFilterBotFlow({ id: 0, name: "" });
													props.setFilterDocuments({ id: 0, name: "" });
													props.setFilterAppointment({ id: 0, name: "" });
													props.setFilterBalance({ id: 0, name: "" });
													props.setFilterRenewalChoice({ id: 0, name: "" });
													props.setFilterTenantType({ id: 0, name: "" });
													dispatch(closeModal());
												}}
											>
												Clear Filters
											</button>
											<button
												className="relative justify-center inline-flex text-white uppercase items-center px-8 py-2 rounded-full border text-sm focus:z-10 focus:outline-none border-primary bg-primary hover:bg-primary_hover focus:ring-primary focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 shadow-md font-bold"
												onClick={() => doFilter()}
											>
												Apply Filters
											</button>
										</div>
									</ErrorBoundary>
								</Dialog.Panel>
							</div>
						</div>
					</Transition.Child>
				</div>
			</Dialog>
		</Transition.Root>
	);
}
